
function assert( expression, text) {
  if (!expression) {
    throw new Error(text);
  }
}

export default assert;
